export const isUserLoggedIn = () => {
  const token = localStorage.getItem("token");
  if (token) {
    // const decryptedData = decryptData(token);
    if (token) {
      return true;
    } else {
      return false;
    }
  }
};

export function truncateFilename(filename, maxLength = 25) {
  if (filename.length <= maxLength) {
    return filename;
  } else {
    let basename = filename.substring(0, filename.lastIndexOf('.'));
    let extension = filename.substring(filename.lastIndexOf('.'));

    let truncatedName = basename.substring(0, maxLength - extension.length) + '...' + extension;
    return truncatedName;
  }
}


export const getValue = (key) => {
  return new Promise((resolve, reject) => {
    try {
      // const data = localStorage?.getItem(key)
      // resolve( data ? JSON.parse(data) : null)

      const data = localStorage.getItem(key);
      if (data) {
        resolve(data || '')
      }
      // resolve(data ? JSON.parse(data) : null);

    } catch (error) {

      console.log('error in fetching local Storage')
      reject(error)
    }
  })

}

export const setDataToLocalStorage = (key, value) => {
  return new Promise((resolve, reject) => {
    try {
      if (value === undefined) {
        console.warn(`Tried to set undefined value for key: ${key}`);
        return resolve(false); // don't save undefined
      }

      const stringified = JSON.stringify(value);
      localStorage.setItem(key, stringified);
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export const truncateString = (str, maxLength = 100) => {
  if (str.length <= maxLength) {
    return str;
  } else {
    return str.substring(0, maxLength - 3) + "...";
  }
};


export const today = new Date();
export const currentYear = today.getFullYear();
export const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

    
  const MonthsArray = [
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];

  const quarters = [
    { name: "1", months: ["01", "02", "03"] },
    { name: "2", months: ["04", "05", "06"] },
    { name: "3", months: ["07", "08", "09"] },
    { name: "4", months: ["10", "11", "12"] },
  ];


 export const getDateRange = (term = "yearly", year = currentYear, month = currentMonth,quarter) => {
  const today = new Date();
  const currentYear = today.getFullYear();

  let startDate, endDate;

  // YEARLY
  if (term === "yearly") {
    if (parseInt(year) === currentYear) {
      // Last 12 months until today
      const pastYear = new Date(today);
      pastYear.setFullYear(today.getFullYear() - 1);
      startDate = `${pastYear.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
      endDate = today.toISOString().split("T")[0];
    } else {
      startDate = `${year}-01-01`;
      endDate = `${year}-12-31`;
    }
  }

  // MONTHLY
  if (term === "monthly") {
    let monthNumber;

    if (/^\d+$/.test(month)) {
      // If month is a number string or number (e.g., "3" or 3)
      monthNumber = parseInt(month);
      if (monthNumber < 1 || monthNumber > 12) throw new Error(`Invalid month: ${month}`);
    } else {
      // If month is a name (e.g., "March")
      const monthObj = MonthsArray.find(m => m.name.toLowerCase() === month.toLowerCase());
      if (!monthObj) throw new Error(`Invalid month name: ${month}`);
      monthNumber = parseInt(monthObj.value);
    }

    const monthIndex = monthNumber - 1;
    startDate = `${year}-${String(monthNumber).padStart(2, "0")}-01`;
    const end = new Date(year, monthIndex + 1, 0); // Last day of month
    endDate = end.toISOString().split("T")[0];
  }

  // QUARTERLY
  if (term === "quarterly") {
    if (!quarter) throw new Error("Quarter is required for quarterly term");

    const selectedQuarter = quarters.find(q => q.name.toLowerCase() === quarter.toLowerCase());
    if (!selectedQuarter) throw new Error(`Invalid quarter: ${quarter}`);

    const startMonthNumber = parseInt(selectedQuarter.months[0]);
    const endMonthNumber = parseInt(selectedQuarter.months[2]);

    if (startMonthNumber < 1 || startMonthNumber > 12 || endMonthNumber < 1 || endMonthNumber > 12)
      throw new Error(`Invalid months in quarter: ${quarter}`);

    startDate = `${year}-${String(startMonthNumber).padStart(2, "0")}-01`;
    const end = new Date(year, endMonthNumber, 0); // Last day of quarter's end month
    endDate = end.toISOString().split("T")[0];
  }

  return { startDate, endDate };
};

export  const getMicrositeUrl = (partnerName) => {
  const baseUrl = process.env.REACT_APP_MICROSITE_BASE_URL;
  if (!baseUrl) return "";

  // Local / Dev → no subdomain
  if (baseUrl?.includes("localhost") || baseUrl?.includes("web.core.windows.net")) {
    return baseUrl.startsWith("http") ? baseUrl : `https://${baseUrl}`;
  }

  // Prod → dynamic subdomain
  // Convert partner name to URL-safe format
  const safePartner = partnerName?.toLowerCase()?.replace(/\s+/g, "-");
  return `https://${safePartner}.${baseUrl}`;
};


 export const getYouTubeVideoId = (url) => {
      if (!url) return null;

  const regExp =
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^#&?]{11})/;

  const match = url.match(regExp);
  return match ? match[1] : null;
  };